// extracted by mini-css-extract-plugin
module.exports = {"entryModalWrapper":"EntryModal_entryModalWrapper__2Xdpl","instructionHolder":"EntryModal_instructionHolder__1bJ0B","arrowKeys":"EntryModal_arrowKeys__1fXLw"};